var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '../../utils/cn';
import { useImage } from '../../hooks/use-image';
import { useSite } from '../../hooks/use-site';
import { useLink } from '../../hooks/use-link';
var cls = classNames('site-logo');
export var SiteLogoDefaultProps = {}; // -------- Child Component Props -------->
// -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    cursor: pointer;\n\n    .gatsby-image-outer-wrapper,\n    .gatsby-image-wrapper {\n      max-width: 100%;\n    }\n\n    img {\n      max-width: 100%;\n    }\n  "], ["\n    cursor: pointer;\n\n    .gatsby-image-outer-wrapper,\n    .gatsby-image-wrapper {\n      max-width: 100%;\n    }\n\n    img {\n      max-width: 100%;\n    }\n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var SiteLogo = function SiteLogo(props) {
  var className = props.className,
      variant = props.variant;

  var _a = useSite(),
      logo = _a.logo,
      logoInverted = _a.logoInverted;

  var Image = useImage();
  var navigate = useLink().navigate;

  var onClick = function onClick() {
    navigate('/');
  };

  var hasLogoInverted = logoInverted && logoInverted.url;
  var hasLogo = logo && logo.url;
  var logoToUse = hasLogo && logo || hasLogoInverted && logoInverted;
  var logoInvertedToUse = hasLogoInverted && logoInverted || hasLogo && logo;
  return React.createElement(My.Container, {
    onClick: onClick,
    className: cls.name(className)
  }, React.createElement(Image, {
    image: variant === 'inverted' ? logoInvertedToUse : logoToUse
  }));
};
SiteLogo.cls = cls;
SiteLogo.defaultProps = SiteLogoDefaultProps;
var templateObject_1, templateObject_2;